import { buildUrl } from "../../utils";
import { ReportTemplatePeriodEnum } from "../../../../api-clients/ts";
import store from "../../store";
import { computed } from "vue";
const reportUrl = (template) => {
    // @ts-ignore
    return buildUrl('reports/run', [], reportQueryParameters(template));
};
const reportQueryParameters = (template) => {
    let params = {
        id: template.id ?? undefined,
        title: template.title,
        subject: template.subject,
        filters: JSON.stringify(template.filters),
        sort: template.sort,
        group_by: template.group_by,
        sub_group_by: template.sub_group_by,
        date_filter: template.date_filter,
        shared: !!template.shared ? 1 : 0,
        columns: JSON.stringify(template.columns),
        period: template.period,
        from: template.from,
        to: template.to,
    };
    let i;
    for (i in params) {
        if (!params[i]) {
            delete (params[i]);
        }
    }
    return params;
};
const currentTemplate = computed(() => {
    const dataViewState = store.state;
    return {
        id: undefined,
        title: dataViewState.dataView.title,
        subject: dataViewState.dataView.resource.handle,
        filters: dataViewState.dataView.currentFilters,
        sort: dataViewState.dataView.currentSortOrder,
        period: ReportTemplatePeriodEnum.Last90,
        date_filter: undefined,
        shared: true,
        columns: [],
    };
});
export { reportUrl, reportQueryParameters, currentTemplate, };
